export default __webpack_public_path__ + "static/media/frame-chieftain.c96d18a8.png";